<template>
  <div class="blood-oxygen-report-configuration">
    <div class="blood-oxygen-report-configuration-container">
      <div class="blood-oxygen-report-configuration-container-top">
       
        
        <button v-show="currentComponent === 'display'&&newReportSwitchEnabled" class="blood-oxygen-report-configuration-container-top-edit"
          @click="customPreview">
          电子版预览
        </button>
        <button v-show="currentComponent === 'display'&&newReportSwitchEnabled" class="blood-oxygen-report-configuration-container-top-edit"
          @click="printPreview">
          打印预览
        </button>
        <button v-show="currentComponent === 'display'" class="blood-oxygen-report-configuration-container-top-edit"
          @click="onEditClick">
          编辑
        </button>
      </div>
      <div class="blood-oxygen-report-configuration-container-bottom">

        <component :is="currentComponent"
        :newReportSwitchEnabled="newReportSwitchEnabled"
         :model="settingInfoModel" @onCancelClick="onEditCancelClick"
          @onSaveClick="onSaveClick" 
          @saveInfo="onSaveInfo"
          :canSwitch="currentComponent === 'display'"
          :isCombineDateAndEvent="isCombineDateAndEvent"
          :isCombineSignAndPulse="isCombineSignAndPulse"
           @onSwitchChange="onSwitchChange"
          >
        </component>
          
      </div>
    </div>

    <!-- 血氧报告预览弹框 -->
    <blood-oxygen-report-preview-dialog
      :visible.sync="previewDialogVisible"
      :config-data="previewConfigData"
      @close="onPreviewClose"
    />
  </div>
</template>
<script>
// import BloodOxygenReportPreviewDialog from "@c/common/blood-oxygen-report-preview-dialog.vue";

export default {
  components: {
    Display: () => import("@c/setting/blood-oxygen-report-configuration/display/display.vue"),
    Edit: () => import("@c/setting/blood-oxygen-report-configuration/edit/edit.vue"),
    BloodOxygenReportPreviewDialog: () => import("@c/common/blood-oxygen-report-preview-dialog.vue")
  },

  data () {
    return {
      currentComponent: "display",
      rawSettingInfoModel: {},
      editedSettingInfoModel: {},
      isCombineSignAndPulse: false,
      isCombineDateAndEvent: false,
      newReportSwitchData: { switchStatus: 0 },
      previewDialogVisible: false,
      previewConfigData: {}
    }
  },

  computed: {
    hospitalID: function () {
      return this.$store.state.selectedHospital.hospitalid
    },
    settingInfoModel() {
      const settingInfoModel = this.rawSettingInfoModel;
      return settingInfoModel;
    },
     // 在计算属性中转换数字为布尔值
     newReportSwitchEnabled() {
      return this?.newReportSwitchData?.switchStatus === 1;
    },
  },

  watch: {
    hospitalID: function () {
      this.currentComponent = "display";
      // 先获取开关状态，然后再获取配置信息
      this.getSwitchStatus().then(() => {
        this.getInfo();
      });
    },
  },

  created() {
    // 先获取开关状态，然后再获取配置信息
    this.getSwitchStatus().then(() => {
      this.getInfo();
    });
  },

  methods: {
    onEditClick() {
      if (this.currentComponent === "display") {
        this.currentComponent = "edit";
      } else {
        this.currentComponent = "display";
      }
    },
    printPreview() {
      console.log('打开打印预览，当前配置数据:', this.rawSettingInfoModel);
      
      const queryParams = {
        autoPrint: 'true',
      };

      if (this.rawSettingInfoModel) {
        if (this.rawSettingInfoModel.sopReportLogo) {
          queryParams.sopReportLogo = encodeURIComponent(this.rawSettingInfoModel.sopReportLogo);
        }
        if (this.rawSettingInfoModel.sopReportHeaders) {
          queryParams.sopReportHeaders = encodeURIComponent(this.rawSettingInfoModel.sopReportHeaders);
        }
        if (this.rawSettingInfoModel.sopReportSubTitle) {
          queryParams.sopReportSubTitle = encodeURIComponent(this.rawSettingInfoModel.sopReportSubTitle);
        }
        
        // 添加模块配置参数
        if (this.rawSettingInfoModel.sleepStructureModuleConfig) {
          queryParams.sleepStructureModuleConfig = encodeURIComponent(JSON.stringify(this.rawSettingInfoModel.sleepStructureModuleConfig));
        }
        if (this.rawSettingInfoModel.spo2PulseModuleConfig) {
          queryParams.spo2PulseModuleConfig = encodeURIComponent(JSON.stringify(this.rawSettingInfoModel.spo2PulseModuleConfig));
        }
       
        
        if (this.rawSettingInfoModel.spo2PulseSecondaryTitle) {
          queryParams.spo2PulseSecondaryTitle = encodeURIComponent(this.rawSettingInfoModel.spo2PulseSecondaryTitle);
        }
        if (this.rawSettingInfoModel.sleepStructureSecondaryTitle) {
          queryParams.sleepStructureSecondaryTitle = encodeURIComponent(this.rawSettingInfoModel.sleepStructureSecondaryTitle);
        }
      }
      
      console.log('传递给打印页面的查询参数:', queryParams);

      const url = this.$router.resolve({
        name: 'BloodOxygenReportPrint',
        query: queryParams
      }).href;
      window.open(url, '_blank', 'width=1200,height=800');
    },
   
    async customPreview(){
      console.log('电子版预览');
      console.log('当前配置数据:', this.rawSettingInfoModel);
      
      // 在打开预览弹框前，先设置配置数据
      this.previewConfigData = { ...this.rawSettingInfoModel };
      
      // 打开预览弹框
      this.previewDialogVisible = true;
    },

    onPreviewClose() {
      this.previewDialogVisible = false;
      this.previewConfigData = {}; // 清空配置数据
    },

    onEditCancelClick() {
      this.currentComponent = "display";
    },

    onSaveClick(settingInfoModel) {
      this.editedSettingInfoModel = settingInfoModel;
      this.saveInfo();
    },

    onSaveInfo(saveCount) {
      console.log('收到保存事件，保存次数:', saveCount);
      // 可以在这里添加其他逻辑，比如显示保存成功的消息等
    },

    async getInfo() {
      console.log('获取报告配置，当前开关状态:', this.newReportSwitchEnabled, this.newReportSwitchData);
      
      if(this.newReportSwitchEnabled){
        try {
        const params = {
          "hospitalId": this.hospitalID
        };
        const data = await this.$api.getNewBloodOxygenReportConfig(params);
        console.log('获取报告配置，当前配置数据:', data);
        this.rawSettingInfoModel = data;
      } catch (error) {
        this.$toast.showRed(error);
      }
      }else{
        try {
        const params = {
          "hospitalId": this.hospitalID
        };
        const data = await this.$api.getBloodOxygenReportConfig(params);
        this.rawSettingInfoModel = data;
      } catch (error) {
        this.$toast.showRed(error);
      }
      }
    
     
    },


    async getSwitchStatus() {
      try {
        const params = {
          "hospitalId": this.hospitalID
        };
        const data = await this.$api.getBloodOxygenReportSwitchStatus(params);
        this.newReportSwitchData = data;
        console.log('开关状态获取完成:', this.newReportSwitchData, '是否启用新版:', this.newReportSwitchEnabled);
      } catch (error) {
        this.$toast.showRed(error);
      }
    },

    async toggleReportSwitch(enabled) {
    try {
      const params = {
        "hospitalId": this.hospitalID,
        "switchStatus": enabled ? 1 : 0
      };
      await this.$api.updateBloodOxygenReportSwitchStatus(params);
      // this.$toast.showGreen(enabled ? "新版报告已启用" : "新版报告已禁用");
      // 重新获取最新状态
      await this.getSwitchStatus();
    } catch (error) {
      this.$toast.showRed(error);
    }
  },
  
  // 处理子组件的开关变化事件
  onSwitchChange(enabled) {
    this.toggleReportSwitch(enabled);
  },

    async saveInfo() {
      if(this.newReportSwitchEnabled){
        try {
          let model = this.editedSettingInfoModel
          const params = {
            hospitalId: this.hospitalID,
            sopReportHeaders: model.sopReportHeaders,
            sopReportSign: model.sopReportSign,
            sopReportSignDate: model.sopReportSignDate,
            sopReportSubTitle: model.sopReportSubTitle,
            sopReportLogo: model.sopReportLogo,
            sleepStructureSwitch: model.sleepStructureSwitch ? 1 : 0,
            sleepStructureModuleConfig: JSON.stringify(model.sleepStructureModuleConfig) ,
            sleepStructureSecondaryTitle: model.sleepStructureSecondaryTitle,
            spo2PulseReportSwitch: model.spo2PulseReportSwitch ? 1 : 0,
            spo2PulseModuleConfig: JSON.stringify(model.spo2PulseModuleConfig) ,
            spo2PulseSecondaryTitle: model.spo2PulseSecondaryTitle,
           
          };
          
          // 如果有 id 则添加到参数中
          if (this.rawSettingInfoModel.id) {
            params.id = this.rawSettingInfoModel.id;
          }
          
          console.log('model',model);
          console.log('保存参数:', params);
          console.log('是否有ID:', this.rawSettingInfoModel.id);
          
          // 根据是否有 id 来判断调用编辑还是新增接口
          if (this.rawSettingInfoModel.id) {
            await this.$api.editNewBloodOxygenReportConfig(params);
          } else {
            await this.$api.addNewBloodOxygenReportConfig(params);
          }
          
          this.$toast.showGreen("报告配置成功");
          this.currentComponent = "display";
          this.getInfo();
        } catch (error) {
          this.$toast.showRed(error);
        }
      }else{
        try {
          let model = this.editedSettingInfoModel
          const params = {
            hospitalId: this.hospitalID,
            sopReportHeaders: model.sopReportHeaders,
            sopReportSign: model.sopReportSign,
            sopReportSignDate: model.sopReportSignDate,
            sopReportSubTitle: model.sopReportSubTitle,
            sopReportLogo: model.sopReportLogo,
          };
          const _ = await this.$api.editBloodOxygenReportConfig(params);
          this.$toast.showGreen("报告配置成功");
          this.currentComponent = "display";
          this.getInfo();
        } catch (error) {
          this.$toast.showRed(error);
        }
      }
     
    },
  },
};
</script>
  
<style lang="scss" scoped>
.blood-oxygen-report-configuration {
  background-color: white;
  border-radius: rem(2);
  width: 100%;
  height: 100%;

  &-container {
    height: 100%;
    // overflow: hidden;
    // overflow-y: auto;
    box-sizing: border-box;
    padding: rem(0) rem(36) rem(50);

    &-top {
      width: 100%;
      height: rem(72);
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      &-edit {
        color: #325FAC;
        font-size: rem(14);
        border-radius: rem(4);
        border: rem(1) solid #325FAC;
        width: rem(88);
        height: rem(32);
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: rem(12);
      }
    }

    &-bottom {
      width: 100%;
      height: 95%;
      overflow-y: auto;
    }
  }
}
</style>